import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../helper";
import { getCounter, saveCounter, setCounter } from "../../redux/counter/counterSlice";
import {
  TextField,
  FormControl,
  FormControlLabel,
  InputLabel,
  Switch,
  Select,
  MenuItem,
  Button,
  Grid,
  Paper,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import toast from "react-hot-toast";

const CounterForm = () => {
  const dispatch = useDispatch();
  const counter = useSelector(getCounter);
  const [form, setForm] = useState({
    title: "",
    count: 0,
    is_active: true,
    type: "GOOGLE_SCHOLAR",
    year: new Date().getFullYear(),
    sequence_no: 1
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setForm(counter);
  }, [counter]);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    if (name === "is_active") {
      setForm(prev => ({ ...prev, [name]: checked }));
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Validation
    if (!form.title.trim()) {
      toast.error("Title is required");
      setLoading(false);
      return;
    }
    if (form.count < 0) {
      toast.error("Count must be a positive number");
      setLoading(false);
      return;
    }
    if (form.type === "GOOGLE_SCHOLAR" && !form.year) {
      toast.error("Year is required for Google Scholar");
      setLoading(false);
      return;
    }
    if (form.type === "RESEARCH_GATE" && !form.sequence_no) {
      toast.error("Sequence number is required for Research Gate");
      setLoading(false);
      return;
    }

    try {
      await dispatch(saveCounter(form)).unwrap();
      toast.success("Counter saved successfully");
      dispatch(setCounter()); // Reset form
    } catch (error) {
      toast.error("Failed to save counter");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} className="p-6">
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2 className="text-2xl font-bold mb-4">Add Counter</h2>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              required
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Count"
              name="count"
              type="number"
              value={form.count}
              onChange={handleChange}
              required
            />
          </Grid>          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                label="Type"
                value={form.type}
                name="type"
                onChange={handleChange}
              >
                <MenuItem value="GOOGLE_SCHOLAR">Google Scholar</MenuItem>
                <MenuItem value="RESEARCH_GATE">Research Gate</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {form.type === "GOOGLE_SCHOLAR" && (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Year"
                name="year"
                type="number"
                value={form.year}
                onChange={handleChange}
                required
              />
            </Grid>
          )}

          {form.type === "RESEARCH_GATE" && (
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Sequence Number"
                name="sequence_no"
                type="number"
                value={form.sequence_no}
                onChange={handleChange}
                required
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={form.is_active}
                  onChange={(e) =>
                    setForm({ ...form, is_active: e.target.checked })
                  }
                  name="is_active"
                />
              }
              label="Active"
            />
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
              startIcon={<SaveIcon />}
            >
              Save Counter
            </Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default CounterForm;
